
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.297 15.852c.703 0 1.18-.493 1.18-1.22V6.126l-.07-1.695 1.46 1.703 1.79 1.781c.21.211.484.367.843.367.633 0 1.11-.46 1.11-1.133 0-.304-.126-.593-.368-.843L8.164 1.227a1.243 1.243 0 00-1.734 0L1.36 6.305c-.243.25-.368.539-.368.843 0 .672.485 1.133 1.117 1.133.352 0 .625-.156.844-.367l1.774-1.781L6.195 4.43l-.07 1.695v8.508c0 .726.469 1.219 1.172 1.219z","fill":"#EAEDF0"}})])
          )
        }
      }
    